(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/requests/sbtech-set-device-type-and-orientation.js') >= 0) return;  svs.modules.push('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/requests/sbtech-set-device-type-and-orientation.js');
"use strict";


const {
  constants,
  betslip
} = svs.sportsbook.sbtech_api_impl;
const {
  setIframeHeight
} = svs.sportsbook.sbtech_api_impl.utils;
svs.sportsbook.sbtech_api_impl.fns.requests.sbtech_setDeviceTypeAndOrientation = (_, _ref) => {
  let {
    iframe
  } = _ref;
  return _ref2 => {
    let {
      deviceType,
      height
    } = _ref2;
    const resizeCallback = () => {
      setIframeHeight(iframe);
    };
    svs.sportsbook.sbtech_api_impl.deviceTypeMode = deviceType;
    betslip.setShouldShowBetslip([constants.MOBILE, constants.TABLET].indexOf(deviceType) > -1);
    if (deviceType === constants.TABLET) {
      setIframeHeight(iframe);
      window.addEventListener('resize', resizeCallback, false);
    } else {
      const extraPadding = deviceType === constants.MOBILE ? 42 : 0;
      iframe.style.height = "".concat(height + extraPadding, "px");
      window.removeEventListener('resize', resizeCallback);
    }
  };
};

 })(window);